import React from "react";

import CartContext from "./context";
import {CartItem} from "./types";

export function useCart() {
  const {
    state: {items, cart, reconcileNotice},
    actions: {add, remove, checkout, checkStock, handleOrder, increase, increaseMany, decrease, dismissReconcileNotice},
  } = React.useContext(CartContext);

  return {
    increase,
    increaseMany,
    decrease,
    add,
    remove,
    checkout,
    checkStock,
    handleOrder,
    dismissReconcileNotice,
    reconcileNotice,
    cart,
    items,
  };
}

export function useProductCartCount(id: CartItem["product"]) {
  const {
    state: {items},
  } = React.useContext(CartContext);

  return items.filter((item) => item.product === id).reduce((count, item) => count + item.count, 0);
}
